import React from 'react';
import './CoursePage.css';

import { PageTitle, Heading, Course } from '../../../components';
import { courses } from '../../../constants';



const CoursePage = () => {  
  return (  
    <>  
      {/* Page Title */}
      <PageTitle title={'Courses'} page={'Courses'} />

      {/* Courses Section */}
      <section className='courses'>

        {/* Section heading */}
        <Heading title={'Our Courses'} subTitle={'Explore Our Latest Courses'} />

        <div className='box-container'>
          {/* Loop through the courses array and render each course */}
          {courses.map((course) => (
            <Course key={course.id} course={course} />
          ))}
        </div>

      </section>
    </>
  );
}

export default CoursePage;